import UpdateSmsCampaignPage from "../../../components/Pages/Campaign/Update/update-sms";

const UpdateSMSCampaign = () => {
  return (
    <div>
      <UpdateSmsCampaignPage />
    </div>
  );
};

export default UpdateSMSCampaign;
